import { VeltCommentBubble, VeltCommentTool } from '@veltdev/react';
import { GenericResource } from 'types/api';
import { RecordType } from 'types/apps';

const VeltGridActionsCellItem = <T extends GenericResource>({
  row,
  recordTypeDefinition,
  forceEnableCommenting,
}: {
  row: T;
  recordTypeDefinition: RecordType<T> | undefined | null;
  forceEnableCommenting?: boolean;
}) => {
  if (
    (!recordTypeDefinition?.nameGetter && !forceEnableCommenting) ||
    !row.id
  ) {
    return null;
  }

  return (
    <>
      <VeltCommentTool
        targetElementId={row.id}
        context={{
          rowDescription: recordTypeDefinition?.nameGetter?.(row),
        }}
        contextOptions={{ partialMatch: true }}
      />
      <VeltCommentBubble
        targetElementId={row.id}
        context={{
          rowDescription: recordTypeDefinition?.nameGetter?.(row),
        }}
        contextOptions={{ partialMatch: true }}
      />
    </>
  );
};

export default VeltGridActionsCellItem;
